import React from 'react';
import { makeStyles } from '@material-ui/core';
import {
    useUpsertReportMappingMutation,
    useTransferReportMutation,
} from '../api/rtkApi';
import { KlpModal } from '@klp/design';

const useStyles = makeStyles(() => ({
    modal: {
        maxWidth: '800px',
    },
}));

type MappingModalProps = {
    open: boolean;
    onClose: () => void;
    titleKey: string;
    children: React.ReactNode;
};

export const MappingModal: React.FC<MappingModalProps> = ({
    open,
    onClose,
    titleKey,
    children,
}) => {
    const classes = useStyles();
    // Check if mutations are in progress
    const [, { isLoading: isUpsertLoading }] = useUpsertReportMappingMutation({
        fixedCacheKey: 'shared-upsert',
    });
    const [, { isLoading: isTransferLoading }] = useTransferReportMutation({
        fixedCacheKey: 'shared-transfer',
    });

    const isSaving = isUpsertLoading || isTransferLoading;

    const handleClose = () => {
        if (!isSaving) {
            onClose();
        }
    };

    return (
        <KlpModal
            isOpen={open}
            onClose={handleClose}
            translation={titleKey}
            className={classes.modal}
        >
            {children}
        </KlpModal>
    );
};
